<template>
  <MainLayout>
    <div class="parallax"
         data-parallax
         data-parallax-speed="0.25"
         data-parallax-direction="down">
      <div class="relative w-screen ">
        <img class="absolute -left-[1vw] top-[-12vh] w-[20vw] opacity-80" src="/images/bg-visual-left-top.webp" alt="">
        <img class="absolute -right-[6vw] top-[18vh] w-[30vw] opacity-60" src="/images/bg-visual-right-top.webp" alt="">
      </div>
    </div>

    <section id="hero" class="max-w-[1080px] lg:m-[auto]">
      <div class="flex items-center lg:mt-[4rem] lg:-mb-[5rem]">
        <div class="flex flex-col gap-y-4.5 lg:gap-y-8">
          <h1 class="text-[32px] leading-[36px] lg:text-[70px] lg:leading-[74px]  font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
            {{ t('pages.info.faq.hero.heading.1') }}
            <span class="text-gradient-primary whitespace-nowrap">{{ t('pages.info.faq.hero.heading.2') }}</span>
            {{ t('pages.info.faq.hero.heading.3') }}
          </h1>

          <div class="flex flex-col gap-6 text-center leading-[27px] lg:text-lg font-semibold max-w-[840px] m-auto">
            <p class="text-dark">{{ t('pages.info.faq.hero.description.1') }}</p>
            <p class="text-lighter">{{ t('pages.info.faq.hero.description.2') }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="faq" class="max-md:-mt-10">
      <div class="flex flex-col w-full max-w-[800px] gap-4">
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.1.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.1.answer') }}<br><br>
            <b>{{ t('pages.info.faq.questions.1.bullet_title') }}</b>
            <br><br>
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.1.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.1.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.1.bullets.3') }}</li>
            </ul>
            <br>
            <b>{{ t('pages.info.faq.questions.1.how') }}</b>
            <br><br>
            <ol class="list-decimal pl-6">
              <li>{{ t('pages.info.faq.questions.1.list.1') }}</li>
              <li>{{ t('pages.info.faq.questions.1.list.2') }}</li>
              <li>{{ t('pages.info.faq.questions.1.list.3') }}</li>
            </ol>
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.2.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.2.answer') }}<br><br>
            <b>{{ t('pages.info.faq.questions.2.how') }}</b>
            <br><br>
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.2.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.3') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.4') }}</li>
              <li>{{ t('pages.info.faq.questions.2.bullets.5') }}</li>
            </ul>
            <br>
            <b>{{ t('pages.info.faq.questions.2.why') }}</b>
            <br><br>
            {{ t('pages.info.faq.questions.2.why_answer') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.3.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.3.answer') }}<br><br>
            <b>{{ t('pages.info.faq.questions.3.what') }}</b>
            <br><br>
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.3.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.3.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.3.bullets.3') }}</li>
              <li>{{ t('pages.info.faq.questions.3.bullets.4') }}</li>
            </ul>
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.4.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.4.answer.1') }}<br><br>
            {{ t('pages.info.faq.questions.4.answer.2') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.5.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.5.answer.1') }}<br><br>
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.5.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.5.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.5.bullets.3') }}</li>
            </ul>
            <br>
            {{ t('pages.info.faq.questions.5.answer.2') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.6.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.6.answer.1') }}<br><br>
            {{ t('pages.info.faq.questions.6.answer.2') }}<br><br>
            {{ t('pages.info.faq.questions.6.answer.3') }}<br><br>
            <ul class="list-disc pl-6">
              <li>{{ t('pages.info.faq.questions.6.bullets.1') }}</li>
              <li>{{ t('pages.info.faq.questions.6.bullets.2') }}</li>
              <li>{{ t('pages.info.faq.questions.6.bullets.3') }}</li>
            </ul>
            <br>
            <b>{{ t('pages.info.faq.questions.6.answer.4') }}</b>
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.7.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.7.answer.1') }}<br><br>
            {{ t('pages.info.faq.questions.7.answer.2') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.8.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.8.answer') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.9.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.9.answer') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.10.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.10.answer.1') }}<br><br>
            {{ t('pages.info.faq.questions.10.answer.2') }}<br><br>
            {{ t('pages.info.faq.questions.10.answer.3') }}<br><br>
            {{ t('pages.info.faq.questions.10.answer.4') }}<br><br>
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.11.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.11.answer') }}
          </p>
        </div>
        <div class="faq-item">
          <p class="title">{{ t('pages.info.faq.questions.12.question') }}</p>
          <p class="content text-lighter border-t border-t-[#ECEDF0] mt-4 pt-6 pb-2">
            {{ t('pages.info.faq.questions.12.answer') }}
          </p>
        </div>
      </div>
    </section>

    <section id="cta" class="backgroundgradient backgroundgradient-bottom">
      <div class="w-full rounded-2xl py-16 max-md:px-14 lg:pt-26 lg:pb-20 relative overflow-hidden">

        <div class="absolute inset-0 z-10 bg-[#E3EEF7]"></div>
        <div class="parallax "
             data-parallax
             data-parallax-speed="0.05"
             data-parallax-direction="down">

          <div class="relative w-full h-full">
            <img class="absolute top-0 left-0 -translate-x-1/3 h-[150%] rotate-[45%]"
                 src="/images/bg-visual-left-top.webp"
                 alt="">

            <img class="absolute right-0 translate-x-1/3 -top-1/4 lg:-top-1/2 h-1/2 lg:h-full rotate-[-20deg]"
                 src="/images/bg-visual-right-top.webp"
                 alt="">
          </div>
        </div>

        <div class="flex flex-col gap-y-5.5 justify-center items-center text-center relative z-30 lg:min-w-[1136px]">
          <h4 class="text-[32px] leading-[42px] lg:text-5xl font-bold text-dark text-center font-markPro block tracking-[-0.08rem]">
            {{ t('main.cta_block.open_your_webshop_today') }}
            <span class="text-gradient-primary whitespace-nowrap">
              {{ t('main.cta_block.its_free') }}
            </span>
          </h4>

          <p class="text-lg lg:text-[24px] text-lighter font-semibold">
            {{ t('main.cta_block.start_generating_more_orders') }}
          </p>

          <a v-track-event="'onboarding_start'"
             href="https://merchant.bistroo.nl/register"
             class="btn btn-lg btn-primary flex items-center gap-x-3 mt-4">
            <span>
              {{ t('main.cta_block.get_started_for_free') }}
            </span>
            <i class="bi bi-arrow-right text-lg mt-[3px]"></i>
          </a>
        </div>
      </div>
    </section>

  </MainLayout>
</template>

<script setup lang="ts">

import { onMounted } from 'vue'
import MainLayout from '@/layouts/MainLayout.vue'
import { useI18n } from 'vue-i18n'

const {t, tm, rt} = useI18n()

onMounted(() => {
  const elements = document.querySelectorAll('.faq-item')

  elements.forEach((el) => {
    el.addEventListener('click', (e: Event) => {
      e.preventDefault()

      const isCollapsed = el.classList.contains('active')

      document.querySelectorAll('.active').forEach((el) => {
        el.classList.remove('active')
      })

      el.classList.toggle('active', !isCollapsed)
    })
  })
})

</script>

<style scoped>
@reference "@/assets/css/main.css";

.faq-item {
  @apply relative p-6 !pr-16 bg-white rounded-xl drop-shadow;
  cursor: pointer;

  .title {
    @apply text-lighter font-semibold;
  }

  .content {
    display: none;
  }

  &::after {
    position:   absolute;
    right:      1.5rem;
    top:        1.5rem;
    content:    "";
    width:      24px;
    height:     24px;
    background: url(/images/ico-plus.svg);
  }

  &.active {
    .title {
      @apply text-gradient-primary;
    }

    .content {
      display: block;
    }

    &::after {
      top:        1.4rem;
      background: url(/images/ico-min.svg);
    }
  }
}
</style>